import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { OeeDataGet, OeeService } from '@app/services/oee.service';

@Component({
  selector: 'tt-oee-data-current',
  templateUrl: './oee-data-current.component.html',
  styleUrls: ['./oee-data-current.component.css'],
  standalone: false,
})
export class OeeDataCurrentComponent implements OnInit, OnDestroy {
    public page?: OeeDataGet;
    public selectedInfo = 'basic_info';
    public saving = false;
    public error = '';
    private destroyed = false;
    public get statusIcon(): string {
        switch (this.page?.color) {
            case 'success': return 'fas fa-check';
            case 'info': return 'fas fa-info-circle';
            case 'warning': return 'fas fa-cog';
            case 'danger': return 'fas fa-ban';
            case 'primary': return 'fas fa-flag';
            case 'default': return 'far fa-square';
            default: return '';
        }
    }
    constructor(private oee: OeeService, @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }
    public async ngOnInit(): Promise<void> {
        const keyno = this.navigator?.params['oeedata_keyno'];
        const redirect = async () => {
            try {
                const target = await this.oee.getCurrentRedirect();
                if (!this.destroyed && target?.webpagename) await this.navigator?.go({ to: target.webpagename, parms: target.parms });
            } catch (error) { this.showError(error); }
        };
        const loadPage = async () => {
            try { const page = await this.oee.getData(keyno === undefined ? undefined : String(keyno)); if (!this.destroyed) this.page = page; }
            catch (error) { this.showError(error); }
        };
        await Promise.all([redirect(), loadPage()]);
    }
    public goToOeeData(): void { this.oee.clearDraft(); this.navigator?.go({ to: 'oeedata-test', parms: { oeedata_keyno: '0' } }); }
    public goToOeeStateLog(): void { if (this.page) this.navigator?.go({ to: 'oeestatelog', parms: { equipment_id: this.page.equipment_id } }); }
    public async saveP2OeeData(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        this.error = '';
        try { await this.oee.saveCurrentData(this.page); }
        catch (error) { this.showError(error); }
        finally { this.saving = false; }
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
    public ngOnDestroy(): void { this.destroyed = true; }

}
